module.exports = __webpack_public_path__ + "img/subscribe_header.9ad81659.svg";